import React from 'react'
import { Image } from 'newComponents'
import classNames from 'classnames'

function ImagePanel(props) {
  const { imageLeft } = props
  return (
    <div
      className={classNames('columns u-paddingtopbottom-medium', {
        'columns-reverse-tablet': !imageLeft
      })}
    >
      {imageLeft ? (
        <>
          <ImageColumn {...props} />
          <TextColumn {...props} />
        </>
      ) : (
        <>
          <TextColumn {...props} />
          <ImageColumn {...props} />
        </>
      )}
    </div>
  )
}

const TextColumn = ({ textColumnFill, imageLeft, noVerticalAlign = false }) => (
  <div
    className={classNames('column is-5-desktop', {
      'is-offset-1-desktop': imageLeft,
      'u-vertical-center': !noVerticalAlign
    })}
  >
    {textColumnFill}
  </div>
)

const ImageColumn = ({ image, imageAlt, noBoxShadow, imageLeft, textOnTop = ''}) => (
  <div
    className={classNames('column is-6-desktop', {
      'is-offset-1-desktop': !imageLeft,
    })}
  >
    {textOnTop}
    <Image
      className={classNames('image height-auto', {
        'box-shadow-2': !noBoxShadow,
      })}
      alt={imageAlt}
      image={image}
    />
  </div>
)

export default ImagePanel
